import React from 'react';
import ProductInfoListItemLoading from '../../../../components/ProductInfo/ListItem/ProductInfoListItemLoading';

const ProductListItemLoading = () => <ProductInfoListItemLoading />;

export default ProductListItemLoading;
